var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 layout-container"},[(_vm.company)?_c('AccountSection',{attrs:{"company":_vm.company}}):_vm._e(),_c('v-divider',{staticClass:"my-4"}),(_vm.company)?_c('SubscriptionSection',{attrs:{"company":_vm.company}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }